exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".dashboard-container[data-v-6d5fa6bc]{margin:30px}.dashboard-text[data-v-6d5fa6bc]{font-size:30px;line-height:46px}\n", ""]);

// exports
